<template>
  <div class="reset_wrapper">
    <div class="reset_container">
      <div class="reset_option">
        <h4>Change Password</h4>
        <el-form :model="changePassword" status-icon :rules="changePasswordRules" ref="changePassword">
          <el-form-item prop="current_pwd">
            <el-input type="password" v-model.trim="changePassword.current_pwd" auto-complete="off" placeholder="Current Password ＊"></el-input>
          </el-form-item>
          <el-form-item prop="new_pwd">
            <el-input type="password" v-model.trim="changePassword.new_pwd" auto-complete="off" placeholder="New Password ＊" @focus="focus_on = true; init = true" @blur="focus_on = false"></el-input>
            <div class="notice" v-show="show_off">
              <p :class="getClass('type1')">8 to 25 characters</p>
              <p :class="getClass('type2')">Upper & lowercase letters</p>
              <p :class="getClass('type3')">At least one number</p>
              <p :class="getClass('type4')">Can not use special numeric except !@#$%^&*()?
                <>._-</p>
            </div>
          </el-form-item>
          <el-form-item prop="re_new_pwd">
            <el-input type="password" v-model.trim="changePassword.re_new_pwd" auto-complete="off" placeholder="Retype New Password ＊"></el-input>
          </el-form-item>
        </el-form>

        <div class="clearfix">
          <a class="cancel" @click='back'>Cancel</a>
          <a class="save" @click='save'>Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { urls } from '@js'

export default {
  data() {
    let validatorEmpty = {
      required: true,
      message: 'This is required!',
      trigger: 'blur'
    }

    return {
      init: false,
      focus_on: false,

      changePassword: {
        current_pwd: '',
        new_pwd: '',
        re_new_pwd: ''
      },

      changePasswordRules: {
        current_pwd: [validatorEmpty],

        new_pwd: [
          validatorEmpty,

          {
            validator: (rule, value, callback) => {
              let res = this.regTest(value)

              if (value !== '' && this.changePassword.re_new_pwd !== '') {
                this.$refs.changePassword.validateField('re_new_pwd')
              }

              if (!res.checkStatus) {
                callback(new Error('incorrect password format'))
                return
              }

              callback()
            },
            trigger: 'blur'
          }
        ],

        re_new_pwd: [
          validatorEmpty,

          {
            validator: (rule, value, callback) => {
              if (value !== this.changePassword.new_pwd) {
                callback(new Error("the password you retyped doesn't match"))
                return
              }

              callback()
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    show_off: function() {
      if (!this.init) return
      if (!this.focus_on && this.passwordCheck.checkStatus) return

      return true
    },

    passwordCheck() {
      return this.regTest(this.changePassword.new_pwd)
    }
  },

  methods: {
    getClass(type) {
      let passwordCheck = this.passwordCheck
      if (passwordCheck.empty) return 'remind_normal'

      if (passwordCheck[type]) {
        return 'remind_pass'
      }

      return 'remind_wrong'
    },

    regTest(password) {
      let empty = password === ''
      let type1 = password.length >= 8 && password.length <= 25
      let type2 = password.search(/[a-z]/) > -1 && password.search(/[A-Z]/) > -1
      let type3 = password.search(/[0-9]/) > -1
      let type4 = /^[A-Za-z0-9\!\@\#\$\%\^\&\*\(\)\?\<\>\._-]*$/.test(password)

      return {
        type1,
        type2,
        type3,
        type4,
        checkStatus: type1 && type2 && type3 && type4,
        empty
      }
    },

    back() {
      this.$router.go(-1)
    },

    save() {
      this.$refs.changePassword.validate(valid => {
        if (!valid) return
        const loading = this.$loading()
        this.axios
          .post('/index/updatePwd', this.changePassword)
          .then(res => {
            loading.close()
            if (res.data.code == '75000') {
              this.$message.success('reset success!')

              setTimeout(() => {
                window.location.assign(urls.ssoLogin)
              }, 500)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch(err => {
            this.$message.error('server error')
            loading.close()
          })
      })
    }
  }
}
</script>

<style lang='less' scoped>
.reset_wrapper {
  width: 1200px;
  margin: 0 auto;
  & > img {
    margin-top: 55px;
  }
  .reset_container {
    margin: 55px 0;
    height: 450px;
    background: #f7f7f7;
    border-radius: 10px;
    .reset_option {
      width: 320px;
      margin: 0 auto;
      h4 {
        padding-top: 50px;
        padding-bottom: 45px;
        font-size: 30px;
        color: #ffb400;
        text-align: center;
      }
      & > div {
        width: 100%;
        a {
          float: left;
          cursor: pointer;
          box-sizing: border-box;
          width: 150px;
          height: 42px;
          line-height: 40px;
          font-size: 18px;
          border-radius: 10px;
          text-align: center;
        }
      }
      a:nth-child(1) {
        margin-right: 20px;
      }
      a.cancel {
        border: 1px solid #fcc800;
        color: #fcc800;
        background: #fff;
      }
      a.save {
        background: #fcc800;
        color: #1e1e1e;
      }

      .notice {
        position: absolute;
        left: 330px;
        top: 0;
        padding-left: 20px;
        width: 290px;
        line-height: 15px;
        font-size: 13px;
        color: #ffffff;
        white-space: nowrap;
        // background: url('~@img/dot_remind.png') no-repeat 0 center;
        p {
          padding-left: 14px;
          line-height: 14px;
          margin-bottom: 5px;
          text-indent: 0.5em;
          background: url('~@img/notice_icons.png') no-repeat 0 0;
        }

        .remind_normal {
          background-position: 0 0;
          color: #c4c4c4;
        }
        .remind_pass {
          background-position: 0 -14px;
          color: #31cd7b;
        }
        .remind_wrong {
          background-position: 0 -28px;
          color: #fd4e4e;
        }
      }
    }
  }
}
</style>
<style lang="less">
.reset_option {
  .el-form-item__content {
    line-height: 1.5;
  }

  .el-form-item__error {
    padding-top: 2px;
  }
}
</style>




// WEBPACK FOOTER //
// resetcode.vue?15527ed7